import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-end my-4" }
const _hoisted_2 = { class: "w-full text-sm text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "text-white bg-primary" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Season"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Winner"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Extra"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Table"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Briefcase"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Unscheduled"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "# Unscheduleds"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" }, "Bonus Unscheduled"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-2" })
  ])
], -1)
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "py-2" }
const _hoisted_6 = { class: "py-2" }
const _hoisted_7 = { class: "py-2" }
const _hoisted_8 = { class: "py-2" }
const _hoisted_9 = { class: "py-2" }
const _hoisted_10 = { class: "py-2" }
const _hoisted_11 = { class: "py-2" }
const _hoisted_12 = { class: "py-2" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Edit ")
const _hoisted_14 = { class: "flex gap-x-10" }
const _hoisted_15 = { class: "flex gap-x-10" }
const _hoisted_16 = { class: "flex gap-x-10" }
const _hoisted_17 = { class: "flex gap-x-10" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Set As Current")

import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import { computed, onMounted, ref } from 'vue';
import { Season } from '@/typings/season';
import { useSeasonStore } from '@/store/season';
import { cloneDeep } from 'lodash';
import Button from '@/components/UI/Button.vue';
import { apiSeasons } from '@/api/season';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const creationModalVisible = ref(false);
const season = ref<Season>();

const seasonStore = useSeasonStore();

function openCreate() {
  season.value = cloneDeep(seasonStore.seasons[0]);
  delete season.value.SeasonId;
  const seasonNameParts = season.value.Name.split(' ');
  const seasonNumber = parseInt(seasonNameParts[1], 10);
  season.value.Name = `Season ${seasonNumber + 1}`;
  creationModalVisible.value = true;
}

function editSeason(editingSeason: Season) {
  season.value = cloneDeep(editingSeason);
  creationModalVisible.value = true;
}

async function saveModal() {
  creationModalVisible.value = false;
  if (!season.value) return;

  if (season.value?.SeasonId) {
    await apiSeasons.updateSeason(season.value);
  } else {
    await apiSeasons.postSeason(season.value);
  }
  await seasonStore.getSeasons();
}

function setCurrent() {
  if (season.value) {
    seasonStore.setCurrentSeason(season.value);
  }
}

const modalHeader = computed(() =>
  season.value?.SeasonId ? 'Edit a season' : 'Set up a season'
);
onMounted(() => {
  seasonStore.getCurrentSeason();
  seasonStore.getSeasons();
});

return (_ctx: any,_cache: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Button, {
        label: "Add Season",
        onClick: openCreate
      })
    ]),
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(seasonStore).seasons, (s) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: s.Name,
            class: _normalizeClass([
          'border-t',
          { 'bg-blue-200': _unref(seasonStore).current?.SeasonId === s.SeasonId },
        ])
          }, [
            _createElementVNode("td", _hoisted_4, _toDisplayString(s.Name), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(s.WinnerPointValue), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(s.QuestionPointValue), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(s.TablePointValue), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(s.BriefcasePointValue), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(s.UnscheduledPointValue), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(s.UnscheduledCount), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(s.AllUnscheduledBonusValue), 1),
            _createElementVNode("td", _hoisted_12, [
              _createVNode(Button, {
                class: "cursor-pointer",
                onClick: ($event: any) => (editSeason(s))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_fa_icon, {
                    icon: "pencil-alt",
                    class: "mr-2"
                  }),
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 2))
        }), 128))
      ])
    ]),
    (season.value && creationModalVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: _unref(modalHeader),
          onClose: _cache[9] || (_cache[9] = ($event: any) => (creationModalVisible.value = false))
        }, {
          footer: _withCtx(() => [
            _createVNode(Button, {
              label: "Save",
              onClick: saveModal
            }),
            (
          season.value.SeasonId && _unref(seasonStore).current?.SeasonId !== season.value.SeasonId
        )
              ? (_openBlock(), _createBlock(Button, {
                  key: 0,
                  onClick: setCurrent
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(Button, {
              label: "Cancel",
              type: "secondary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (creationModalVisible.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(TextField, {
                modelValue: season.value.Name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((season.value.Name) = $event)),
                title: "Name",
                "max-length": 36
              }, null, 8, ["modelValue"]),
              _createVNode(TextField, {
                modelValue: season.value.WinnerPointValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((season.value.WinnerPointValue) = $event)),
                title: "Points Per Winner",
                type: "number"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(TextField, {
                modelValue: season.value.QuestionPointValue,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((season.value.QuestionPointValue) = $event)),
                title: "Points Per Extra",
                type: "number"
              }, null, 8, ["modelValue"]),
              _createVNode(TextField, {
                modelValue: season.value.TablePointValue,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((season.value.TablePointValue) = $event)),
                title: "Points Per Table",
                type: "number"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(TextField, {
                modelValue: season.value.BriefcasePointValue,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((season.value.BriefcasePointValue) = $event)),
                title: "Points Per Briefcase",
                type: "number"
              }, null, 8, ["modelValue"]),
              _createVNode(TextField, {
                modelValue: season.value.UnscheduledPointValue,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((season.value.UnscheduledPointValue) = $event)),
                title: "Points Per Unscheduled",
                type: "number"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(TextField, {
                modelValue: season.value.UnscheduledCount,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((season.value.UnscheduledCount) = $event)),
                title: "Unscheduled Per Card",
                type: "number"
              }, null, 8, ["modelValue"]),
              _createVNode(TextField, {
                modelValue: season.value.AllUnscheduledBonusValue,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((season.value.AllUnscheduledBonusValue) = $event)),
                title: "Bonus for all Unscheduled",
                type: "number"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["header"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})